import script from "./StartScreenInterface.vue?vue&type=script&setup=true&lang=ts"
export * from "./StartScreenInterface.vue?vue&type=script&setup=true&lang=ts"

import "./StartScreenInterface.vue?vue&type=style&index=0&id=2e8ca889&scoped=true&lang=css"
import "./StartScreenInterface.vue?vue&type=style&index=1&id=2e8ca889&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e8ca889"]])

export default __exports__